import { Button, Checkbox, DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderReplyProfile extends Layout {
    buttonCustomizeFilename: Button;
    buttonCustomizeTransCtrlNo: Button;
    buttonSetup: Button;
    buttonViewMasterBatch: Button;
    checkboxAutoCreateOrder: Checkbox;
    checkboxAutoCreateReply: Checkbox;
    checkboxAutoSendReply: Checkbox;
    checkboxCancelRequiresReply: Checkbox;
    checkboxChangeRequiresReply: Checkbox;
    checkboxDeclineReason: Checkbox;
    checkboxMasterBatch: Checkbox;
    checkboxOriginalRequiresReply: Checkbox;
    checkboxRequiresReply: Checkbox;
    labelDataVerification: Label;
    panelCheckBoxes: Panel;
    panelReply: Panel;
    panelRequiredReply: Panel;
    panelTextboxes: Panel;
    sourceEdiDataRule: DataSource;
    sourceEdiRequiredField: DataSource;
    sourceEdiTemplate: DataSource;
    sourceEdiorderProfileDisplay: DataSource;
    tableRequiredField: Table;
    textboxAltPartnerId: Textbox;
    textboxCommId: Textbox;
    textboxFilename: Textbox;
    textboxNextBatch: Textbox;
    textboxPartnerId: Textbox;
    textboxTemplateId: Textbox;
    textboxTransmitMethod: Textbox;
    textboxVersion: Textbox;
    textboxtTransCtlNo: Textbox;
}
